export default {
  computed: {
    custom () {
      return !this.plain
    }
  },
  props: {
    plain: {
      type: Boolean,
      default: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components-base/mixins/form-custom.js